<div class="loading-container">
    <div class="spinner-1"></div>
</div>
